export const themes = {
  "/": "dark",
  "/about/": "light",
  "/contact/": "light",
  "/events/": "light",
};
